<template>
    <div class="reg-google-container">
      <div class="reg-google-content">
        <!-- <div>
          <img
            src="../../../assets/img/logo-merah.png"
            class="reg-google-logo"
            alt=""
          />
        </div> -->
        <div class="reg-google-header">
          <div class="welcome-text">Selamat Datang</div>
          <div class="sub-welcome-text">
            Silakan masukkan informasi Anda
          </div>
        </div>
        <div class="reg-google-form-container">
          <div class="reg-google-form-wrapper">
            <div class="reg-google-input-field">
              <div class="reg-google-input-label">Nama</div>
              <input
                type="text"
                class="reg-google-input"
                placeholder="Nama"
                v-model="nama"
              />
            </div>
            <div class="reg-google-input-field">
              <div class="reg-google-input-label">Nama Company</div>
              <input
                type="text"
                class="reg-google-input"
                placeholder="Nama Company"
                v-model="namaCompany"
              />
            </div>
            
            <div class="reg-google-btn">Kirim</div>
            <!-- <div class="email-sipm">
              <p>Jika mengalami kendala, mohon dapat menghubungi email <a href="#">SIPM_Member_Team@sinarmasmining.com</a></p>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import { api } from '../../services/config'
  import axios from 'axios'
  export default {
    components: {
      Loading: () => import('@/components/utils/Loading'),
      Alert: () => import('@/components/Modal/Alert'),
    },
    data() {
      return {
        nama: '',
        namaCompany: '',
      }
    },
  }
  </script>
  